// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1937":"570bf66a85a1fac3","2888":"93c1a03895d6fa7f"}[chunkId] + ".css";
};